(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["image--image-with-text-compare"] && !window.DesignMode) return;
  try {
    
new BeerSlider(document.getElementById('beers-slider'));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-location"]) return;
  try {
    
    // <!-- Initialize Swiper -->
var swiper = new Swiper(".location-logo-swiper", {
  slidesPerView: 5,
  spaceBetween: 10,
  loop: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    640: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: 40,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 50,
    },
    1200: {
      slidesPerView: 5,
      spaceBetween: 40,
    },
  },
  autoplay: {
    delay: 3500,
    disableOnInteraction: false
  },
});
    
  } catch(e) { console.error(e); }
})();

})();
